import React from 'react';
import { DASH } from '../../utils/marketFormatters';

/**
 * Small "spotlight" card used for Live Market top cards and Crowd Insights
 * participation stats — a label, a headline value, and an optional runner
 * subtitle/badge row.
 */
export const MarketInsightCard = ({ icon, label, value, subtitle, badge, accent = 'blue' }) => (
  <div className={`mk-insight-card mk-insight-card--${accent}`}>
    {icon && <span className="mk-insight-icon" aria-hidden="true">{icon}</span>}
    <div className="mk-insight-body">
      <span className="mk-insight-label">{label}</span>
      <span className="mk-insight-value">{value ?? DASH}</span>
      {subtitle && <span className="mk-insight-subtitle">{subtitle}</span>}
    </div>
    {badge && <span className={`mk-pill mk-pill--${badge.tone || 'default'}`}>{badge.text}</span>}
  </div>
);

export default MarketInsightCard;
